/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Set_Default_Inactive_BlockedInputs */

const cs_templates_set_default_inactive_blocked = /** @type {(inputs: Templates_Set_Default_Inactive_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní šablonu nelze nastavit jako výchozí.`)
};

const en_templates_set_default_inactive_blocked = /** @type {(inputs: Templates_Set_Default_Inactive_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive templates cannot be set as default.`)
};

/**
* | output |
* | --- |
* | "Inactive templates cannot be set as default." |
*
* @param {Templates_Set_Default_Inactive_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_set_default_inactive_blocked = /** @type {((inputs?: Templates_Set_Default_Inactive_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Set_Default_Inactive_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_set_default_inactive_blocked(inputs)
	return cs_templates_set_default_inactive_blocked(inputs)
});